var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.49995 8.08516L2.76495 6.35016C2.56995 6.15516 2.25495 6.15516 2.05995 6.35016C1.86495 6.54516 1.86495 6.86016 2.05995 7.05516L4.14995 9.14516C4.34495 9.34016 4.65995 9.34016 4.85495 9.14516L10.1449 3.85516C10.3399 3.66016 10.3399 3.34516 10.1449 3.15016C9.94995 2.95516 9.63495 2.95516 9.43995 3.15016L4.49995 8.08516Z",
    fill: "#2B8C34"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheck);
export default __webpack_public_path__ + "static/media/check.8bd8d1a72705224d343bd0be095be9b7.svg";
export { ForwardRef as ReactComponent };